<template>
    <div id="create-announcement-page" class="dashboard-view">
        <div class="container">
            <section class="content">
                <h1>Create Announcement</h1>
                <AnnouncementForm @formSubmitted="createAnnouncement" />
            </section>
        </div>
    </div>
</template>

<script>
import AnnouncementForm from "@/components/forms/AnnouncementForm.vue";
import axios from "axios";
const endpoint = process.env.VUE_APP_API_BASE + '/announcements/create'

export default {
    name: 'AnnouncementsCreate',
    components: {AnnouncementForm},
    methods: {
        createAnnouncement(data) {
            axios.post(endpoint, data)
                .then(() => {
                    //console.log(response)
                    alert('Announcement created successfully')
                    this.$router.push('/announcements')
                })
                .catch(error => {
                    console.log(error.response)
                    if (error.response && error.response.data?.data) {
                        alert(error.response.data.data)
                    }
                    else {
                        alert('Error occurred!')
                    }
                })
        }
    }
}
</script>

<style lang="scss" scoped>
</style>